module.exports = __webpack_public_path__ + "static/img/top-img2.a5e9d88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top-img2.png
// module id = WEuT
// module chunks = 0